import { marked } from "marked";
import DOMPurify from "dompurify";

// Nothing the model writes may load from elsewhere: a remote URL could carry a
// student's name once labels are hydrated.
const PURIFY = {
  FORBID_TAGS: ["img", "picture", "source", "video", "audio", "iframe", "object", "embed", "style", "link"],
  FORBID_ATTR: ["style", "srcset", "background"],
};

// The model's Markdown is untrusted: sanitise it first, then hydrate labels in
// visible text only, never inside link targets.
export const renderMarkdown = (md, hydrateText = (text) => text) => {
  let html;
  try {
    html = marked.parse(typeof md === "string" ? md : "", { gfm: true });
  } catch {
    return "";
  }
  const template = document.createElement("template");
  template.innerHTML = DOMPurify.sanitize(html, PURIFY);
  const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT);
  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    node.nodeValue = hydrateText(node.nodeValue);
  }
  template.content.querySelectorAll("a").forEach((a) => {
    a.setAttribute("target", "_blank");
    a.setAttribute("rel", "noopener noreferrer");
  });
  return template.innerHTML;
};
